// Yuumi — Bond: empowers the ally she's attached to (the Yuumi-aura target),
// reducing their ability cooldown by 1 turn.

import type { Ability, AbilityHit } from "./Ability";
import type { Unit } from "../Unit";
import type { CombatContext } from "../../combat/CombatContext";
import { pickYuumiBondAlly } from "../../combat/UnitFactory";

function pickBondedAlly(caster: Unit, combat: CombatContext): Unit | null {
  const allies = combat.livingUnitsOf(caster.team);
  return allies.find(u => u.id !== caster.id && u.yuumiBoostMult > 1) ?? pickYuumiBondAlly(caster, allies);
}

export const yuumiHeal: Ability = {
  id: "yuumiHeal",
  displayName: "Bond",
  description: "Reduces the attached ally's ability cooldown by 1.",
  iconId: "YuumiE",

  targetShape({ caster, combat }) {
    const ally = pickBondedAlly(caster, combat);
    return ally ? [ally.pos] : [];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const ally = pickBondedAlly(caster, combat);
    if (!ally) return [];
    return [{
      target: ally,
      amount: 0,
      type: "none" as const,
      cdrTurns: 1,
    }];
  },
};
